import React, { useState, useEffect } from 'react';

import { Navbar } from './sections';
import { Redirect, Route, useHistory } from "react-router-dom";
import { Configure, Downloads, KeyPaths, Types, Licenses, Releases, Waitlists } from "./tabs";
import { Flex } from "../../components";
import Media from "react-media";

const Admin = ({ userData, isAdmin, login }) => {
  const [isLoading, setIsLoading] = useState(true);
  const history = useHistory();

  useEffect(() => {

    if (userData) {
      if (isAdmin) {
        setIsLoading(false);
      } else {
        history.push("/")
      }
    } else {
      login();
    }

  }, []);

  if (isLoading) return "";


  return (
    <>
      <Media query={{ minWidth: 1000 }}>
        {matches =>
          <Flex dir={matches ? 'row' : 'column'} w="100%" minw="100vw" h="100%" minh="100vh" style={{ overflow: 'auto' }}>
            <Navbar />
            <Flex dir='column' fg={matches && 1} w={!matches && '100%'} h={matches ? '100%' : 'calc(100% - 60px)'}>
              <Route exact path="/admin/downloads" component={Downloads} />
              <Route exact path="/admin/configure" component={Configure} />
              <Route exact path="/admin/releases" component={Releases} />
              <Route exact path="/admin/key-paths" component={KeyPaths} />
              <Route exact path="/admin/types" component={Types} />
              <Route exact path="/admin/licenses" component={Licenses} />
              <Route exact path="/admin/waitlist" component={Waitlists} />
              <Route exact path="/admin">
                <Redirect to="/admin/licenses" />
              </Route>
            </Flex>
          </Flex>
        }
      </Media>
    </>
  )
}

export default Admin;
